import React, { useState, useRef, useEffect } from "react";

import { Sidebar } from "primereact/sidebar";
import BottomSheetViewForm from "./BottomSheetViewForm";
import { getOrderItemGarmentServicePrice } from "../../services/OrderEditOffer/OrderEditOffer";
import BottomSheetViewFormEdit from "./BottomSheetViewFormEdit";
import BottomSheetViewFormOfferEdit from "./BottomSheetViewFormOfferEdit";

const BottomSheetViewEdit = ({
  visible,
  toggleBottomNavigationViewClosed,
  selectedGarment,
  storeId,
  storeCustomerId,
  bookingOrderId,
  brandId,
  priceId,
  offerEdit,
  offerPriceEnabled,
  garmentMaxProcessCount,
  garmentServiceIcons,
  enabledAmountRoundOff
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [garmentCategoryServicePrice, setGarmentCategoryServicePrice] =
    useState("");

  const fetchOrderItemGarmentServicePrice = async () => {
    try {
      const response = await getOrderItemGarmentServicePrice(
        storeId,
        storeCustomerId,
        selectedGarment.addOns[0].priceListId
      );
      if (!response.data.error) {
        // setAllServicesOfferData(response.data.cartAddOnOfferMapList);
        setGarmentCategoryServicePrice(response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchOrderItemGarmentServicePrice();

    if (selectedGarment) {
      const {
        // garment: {name, code, description, logo},
        // category: {name: categoryName},
        id,
        garmentName,
        garmentCategory,
      } = selectedGarment;
      setName(garmentName);
      // setDescription(description);
      // setImg(logo);
      setCategoryName(garmentCategory); // Corrected from setAmount(nameName);
    }
  }, [selectedGarment]);

  return (
    <div>
      <div>
        <Sidebar
          visible={visible}
          position="bottom"
          onHide={() => toggleBottomNavigationViewClosed(false)}
          style={{
            justifyContent: "flex-start",
          }}
          header={
            <div className="flex gap-4">
              <div>
                <img
                  src={
                    garmentServiceIcons[
                      garmentCategoryServicePrice[0]?.garmentCategory.garment
                        .imageId
                    ]
                      ? `data:image/jpeg;base64,${
                          garmentServiceIcons[
                            garmentCategoryServicePrice[0]?.garmentCategory
                              .garment.imageId
                          ]
                        }`
                      : "Laundry_app_icons/Tshirt.png"
                  }
                  resizeMode="cover"
                  style={{
                    alignSelf: "center", // to center an image
                    width: 70,
                    height: 70,
                  }}
                />
              </div>
              <div className="flex flex-1 flex-column justify-content-center">
                <p className="text-xl text-black-alpha-90 font-semibold text-center">
                  {name?.replace(/_/g, " ")}
                </p>
                <p className="text-xl text-black-alpha-90 font-semibold text-center">
                  {categoryName}
                </p>
              </div>
            </div>
          }
        >
          <div className="border-1" style={{ color: "#c2c2c2" }}></div>
          <div>
            <div />
            {offerEdit === "price" && (
              <BottomSheetViewFormEdit
                selectedGarment={selectedGarment}
                onClose={toggleBottomNavigationViewClosed}
                storeId={storeId}
                storeCustomerId={storeCustomerId}
                bookingOrderId={bookingOrderId}
                offerPriceEnabled={offerPriceEnabled}
                brandId={brandId}
                priceId={priceId}
                garmentCategoryServicePrice={garmentCategoryServicePrice}
                garmentMaxProcessCount={garmentMaxProcessCount}
                enabledAmountRoundOff={enabledAmountRoundOff}
              />
            )}
            {offerEdit === "offer" && (
              <BottomSheetViewFormOfferEdit
                selectedGarment={selectedGarment}
                onClose={toggleBottomNavigationViewClosed}
                storeId={storeId}
                storeCustomerId={storeCustomerId}
                bookingOrderId={bookingOrderId}
                offerPriceEnabled={offerPriceEnabled}
                brandId={brandId}
                priceId={priceId}
              />
            )}
          </div>
        </Sidebar>
      </div>
    </div>
  );
};

export default BottomSheetViewEdit;
